import * as postActions from '../actions/post.actions';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
  fetchOutputSettingsRecord,
  fetchOutputSettingsRecordFailure,
  fetchOutputSettingsRecordSuccess,
  loadOutputSettings,
  loadOutputSettingsFailure,
  loadOutputSettingsSuccess,
  saveOutputSettings,
  saveOutputSettingsFailure,
  saveOutputSettingsSuccess,
} from '../actions/output-settings.actions';

import { Injectable } from '@angular/core';
import { OutputSettingsService } from '../services/output-settings.service';
import { ToastService } from '@services/toast.service';
import { TranslateService } from '@ngx-translate/core';

// Replace with the actual path to your service

@Injectable()
export class OutputSettingsEffects {
  loadOutputSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadOutputSettings),
      mergeMap((action) =>
        this.outputSettingsService
          .fetchOutputSettings(action.objectClassId, action.objectId)
          .pipe(
            map((response) =>
              loadOutputSettingsSuccess({ outputSettings: response }),
            ),
            catchError((error) => of(loadOutputSettingsFailure({ error }))),
          ),
      ),
    ),
  );

  saveOutputSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(saveOutputSettings),
      mergeMap((action) =>
        this.outputSettingsService
          .saveOutputSettings(
            action.objectId,
            action.objectClassId,
            action.outputSettings,
          )
          .pipe(
            map((response) =>
              saveOutputSettingsSuccess({ outputSettings: response }),
            ),
            catchError((error) => {
              this.toastService.showError(
                this.translateService.instant(
                  'output-settings-popup.msg.error-saving-output-settings',
                ),
              );
              return of(saveOutputSettingsFailure({ error }));
            }),
          ),
      ),
    ),
  );

  saveOutputSettingsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveOutputSettingsSuccess),
        map((action) => {
          this.toastService.showSuccess(
            this.translateService.instant(
              'output-settings-popup.msg.output-settings-saved-successfully',
            ),
          );
        }),
      ),
    { dispatch: false },
  );

  fetchOutputSettingsRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchOutputSettingsRecord),
      mergeMap((action) =>
        this.outputSettingsService
          .fetchOutputSettingsRecord(
            action.outputSettingsId,
            action.objectId,
            action.objectClassId,
          )
          .pipe(
            map((response) =>
              fetchOutputSettingsRecordSuccess({ outputSettings: response }),
            ),
            catchError((error) =>
              of(fetchOutputSettingsRecordFailure({ error })),
            ),
          ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private outputSettingsService: OutputSettingsService,
    private toastService: ToastService,
    private translateService: TranslateService,
  ) {}
}
